import { ParagraphProps } from "./types";
import { Paragraph } from "./styled-components";

export { ParagraphProps, Paragraph };
export default Paragraph;
